import React, { ReactNode, useState } from "react";
import clsx from "clsx";
import { StyledAppCard } from "./index.styled";
import { CardProps } from "antd";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";

export type AppCardProps = CardProps & {
  className?: string;
  title?: string | ReactNode;
  action?: ReactNode | string;
  actions?: ReactNode | string[] | React.ReactNode[];
  extra?: ReactNode | string;
  cover?: any;
  footer?: any;
  children?: ReactNode;
  heightFull?: boolean;
  style?: React.CSSProperties;
  borderFull?: boolean;
  borderHeader?: boolean;
  coloredHeader?: boolean;

  collapseIconSide?: "left" | "right";
  collapse?: boolean;
  collapsed?: boolean;

  [x: string]: any;
};

const AppCard: React.FC<AppCardProps> = ({
  title,
  extra,
  children,
  cover,
  className,
  actions,
  heightFull,
  style,
  bordered,
  collapseIconSide = "right",
  collapse = false,
  ...rest
}) => {
  const [collapsed, setCollapsed] = useState(rest?.collapsed || false);

  return (
    <StyledAppCard
      className={clsx({ heightFull: heightFull }, className)}
      title={
        collapse && collapseIconSide === "left" ? (
          <CardExtra
            collapsed={collapsed}
            extra={title}
            setCollapsed={setCollapsed}
            collapseIconSide={collapseIconSide}
          />
        ) : (
          title
        )
      }
      extra={
        collapse && collapseIconSide === "right" ? (
          <CardExtra
            collapsed={collapsed}
            extra={extra}
            setCollapsed={setCollapsed}
            collapseIconSide={collapseIconSide}
          />
        ) : (
          extra
        )
      }
      cover={cover}
      actions={actions as React.ReactNode[]}
      style={style}
      variant={bordered ? "outlined" : "borderless"}
      collapse={collapse}
      collapsed={collapsed}
      {...rest}
    >
      {collapse ? (
        <div
          className={clsx(
            "collapse-content",
            collapsed && "collapse-content-collapsed",
          )}
        >
          {children}
        </div>
      ) : (
        children
      )}
    </StyledAppCard>
  );
};

type CardExtraProps = {
  collapsed: boolean;
  setCollapsed?: (collapsed: boolean) => void;
  extra?: ReactNode | string;
  collapseIconSide?: "left" | "right";
};
const CardExtra = ({
  collapsed,
  extra,
  setCollapsed,
  collapseIconSide,
}: CardExtraProps) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        {collapseIconSide === "left" && (
          <ActionButton
            type="showMore"
            noLabel
            showMoreProps={{ state: !collapsed }}
            onClick={() => setCollapsed(!collapsed)}
            size="small"
          />
        )}
        {extra}
      </div>

      {collapseIconSide === "right" && (
        <ActionButton
          type="showMore"
          noLabel
          showMoreProps={{ state: !collapsed }}
          onClick={() => setCollapsed(!collapsed)}
          size="small"
        />
      )}
    </div>
  );
};

export default AppCard;
